import React from 'react';

export const AlertCircle = (props: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.3" height="13.3" viewBox="0 0 13.3 13.3">
      <g id="alert-circle_1_" transform="translate(-1.051 -1.051)">
        <circle
          fill="none"
          stroke="#cc3c3c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.3px"
          id="Ellipse_357"
          cx="6"
          cy="6"
          r="6"
          className="cls-1"
          transform="translate(1.701 1.701)"
        />
        <path
          fill="none"
          stroke="#cc3c3c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.3px"
          id="Line_432"
          d="M0 0L0 2"
          className="cls-1"
          transform="translate(7.701 5.701)"
        />
        <path
          fill="none"
          stroke="#cc3c3c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.3px"
          id="Line_433"
          d="M0 0L0 0"
          className="cls-1"
          transform="translate(7.701 9.701)"
        />
      </g>
    </svg>
  );
};
